// generated by srcset-codegen
import src from "./twitch.png";
import src2x from "./twitch@2x.png";
import src3x from "./twitch@3x.png";

const width = 16;
const height = 16;
const srcSet = `${src2x} 2x, ${src3x} 3x`;
export default { src, width, height, srcSet };
